// @ts-ignore
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { StudentNav } from '../../common/student-nav/student-nav';
import { FeedColumn } from './feed-column/feed-column';
import { UpcomingDeadlines } from './upcoming-deadlines/upcoming-deadlines';
import { CareerssToExplore } from './careerss-to-explore/careerss-to-explore';
import { CalendarWidget } from './calendar-widget/calendar-widget';
import { ProfileStrip } from './profile-strip/profile-strip';
import { ProfileSetup } from '../../common/profile-setup-dialog/profile-setup';
import { MessagingWidget } from '../../common/messaging-widget/messaging-widget';
import { UserService } from '../../../services/user.service';
import { ProfileService } from '../../../services/profile.service';

@Component({
  selector: 'app-student-view',
  imports: [
    StudentNav,
    ProfileStrip,
    FeedColumn,
    UpcomingDeadlines,
    CareerssToExplore,
    CalendarWidget,
    MatDialogModule,
    MessagingWidget,
  ],
  templateUrl: './student-view.html',
  styleUrl: './student-view.css',
})
export class StudentView implements OnInit {
  /** Guards against opening the profile setup dialog more than once per session. */
  private dialogOpened = false;

  constructor(
    /** Service for setting the browser tab title. */
    private title: Title,
    /** Service for opening Material dialogs. */
    private dialog: MatDialog,
    /** Service for fetching and updating the current authenticated user. */
    private userService: UserService,
    /** Service for checking whether the authenticated user's profile exists. */
    private profileService: ProfileService,
  ) {}

  /**
   * Sets the browser tab title on init.
   * @returns {void}
   */
  ngOnInit(): void {
    this.title.setTitle('Home | Handle');
    // this.checkForProfile();
  }

  /**
   * Checks whether the current student has a profile and opens the ProfileSetup
   * dialog if not. Retries after 500ms if the student record doesn't exist yet
   * (e.g. still being created after registration). Refreshes the user on close.
   *
   * Currently disabled in ngOnInit — uncomment `this.checkForProfile()` to re-enable.
   * @returns {void}
   */
  checkForProfile(): void {
    const user = this.userService.currentUser;
    if (!user) {
      this.userService.getCurrentUser().subscribe({
        next: () => this.checkForProfile(),
      });
      return;
    }

    this.profileService.getMyProfile().subscribe({
      next: (res) => {
        if (!res.exists && !this.dialogOpened) {
          this.dialogOpened = true;
          const ref = this.dialog.open(ProfileSetup, {
            width: '540px',
            disableClose: true,
            height: 'fit-content',
            panelClass: 'pw-dialog',
          });
          ref.afterClosed().subscribe((result) => {
            if (result?.success) {
              this.userService.getCurrentUser().subscribe();
            }
          });
        }
      },
      error: (err) => console.error('getMyProfile error:', err),
    });
  }
}
